<template>
  <div>
    <div class="svg-wrapper">
      <svg viewBox="0 0 24 24">
        <path :d="path" />
      </svg>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    path: {
      type: String,
      'default': () => (''),
    }
  },
})
</script>

<style scoped>
path {
  fill: currentColor;
}
.svg-wrapper { 
  position: relative;
  width: 100%;
  padding-top: 100%;
}
.svg-wrapper svg { 
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
